import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../../TheCage";
import {TheCageGameMode} from "../../server/TheCageGameMode";
import {gsap} from "gsap";
import {TheCageSound} from "../../sound/TheCageSound";
import {TheCageSymbol} from "../../reels/TheCageSymbol";
import {XBombSymbol} from "../../reels/XBombSymbol";
import {GSAPUtils} from "../../utils/GSAPUtils";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreesSpinStickyWildFeature implements SimplePresentation {

    name:string = "FreesSpinStickyWildFeature";

    constructor() {

    }

    public shouldRun():boolean {
        return TheCage.model.data.fsLevel == 4; // TODO check that we dont already have the symbol as well
    }

    public start(controller:SimplePresentationRunnerController):void {

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => {
                controller.finish();
            }});
        tl.add(() => controller.setSkipCallback());

        const symbol = TheCage.freeSpinReelView.avalancheMatrixModel.getSymbolAt({x: 4, y: 1});
        // transform the symbols one by one
        const data = TheCage.freeSpinReelView.transformSymbolAt(symbol.reelId, symbol.reelPosition, "WS");
        const newSym = (<TheCageSymbol>data.newSymbol.positionable);
        newSym.alpha = 0;
        const oldSym = (<TheCageSymbol>data.oldSymbol.positionable);
        tl.add(gsap.to(newSym, {duration : 0.05, alpha : 1}), 0);
        tl.add(() => {
            oldSym.parent.removeChild(oldSym);
            oldSym.destroy();
        });
        tl.add(() => {}, '>0.5');
    }
}
